/**
 * Owner vs grantee on an `Account` (TMMAPP-0016). `access` is the authority for ownership;
 * `myPermissions` remain the authority for what a grantee may do.
 */
import type { Account } from '@/api/accounts';

export function isOwnerAccount(account: Account): boolean {
  return account.access === 'OWNER';
}

/** Owner, `can_view_full`, or `can_edit` (MM-D-11: edit implies view-full). */
export function canViewFullRegister(account: Account): boolean {
  return (
    isOwnerAccount(account) || account.myPermissions.canViewFull || account.myPermissions.canEdit
  );
}

export function canEditAllocations(account: Account): boolean {
  return isOwnerAccount(account) || account.myPermissions.canEdit;
}

/** Owner or a `can_import` grantee (design §4.7). */
export function canImportBatches(account: Account): boolean {
  return isOwnerAccount(account) || account.myPermissions.canImport;
}

export function isForeignCurrency(account: Account): boolean {
  return (
    account.currency !== null &&
    account.operatingCurrency !== null &&
    account.currency !== account.operatingCurrency
  );
}
